<div class="app-merchandise" id="merchandise" fxLayout="column">
    <!-- products display code starts here-->
    <div *ngIf="showOverlay" class="p-msg">
        <span class="p-msg-disp primary-bg-font-color2">Please do not refresh the page while we are
            processing your payment
            {{timer}}</span>
    </div>
    <ng-container *ngIf="activeBlock == 'MerchandiseProd' && selectedProductInfo && !fromMobile">
        <div class="row no-gutters relative">
            <div class="col-5">
                <img src="{{selectedProductInfo?.product_img}}" class="p-img">
                <ng-container *ngIf="selectedProductInfo?.prod_imgs?.length > 0">
                    <div class="mt-10 below-images no-gutters">
                        <img class="b-img" *ngFor="let img of selectedProductInfo.prod_imgs;let i = index"
                            (click)="changeImg(img,i)" src="{{img}}">
                    </div>
                </ng-container>
            </div>
            <div class="col-7 p-info pl-20">
                <div class="p-changes mb-1 fs-15 fw-600">{{selectedProductInfo?.name}}</div>
                <div class="fs-13 text-capitalize h-15 line-clamp line-clamp-1" *ngIf="selectedProductInfo?.brand_name">
                    Brand: {{selectedProductInfo?.brand_name}}</div>
                <div class="p-desc mtb-5 line-clamp" *ngIf="description && !selectedProductInfo?.showDescription"
                    [innerHTML]="description | safe: 'html'"></div>
                <div *ngIf="description && selectedProductInfo?.showDescription"
                    [innerHTML]="selectedProductInfo?.long_description | safe: 'html'">
                </div>
                <span *ngIf="description" class="pointer text-info" (click)="showDesc()">Show
                    {{selectedProductInfo.showDescription ? "Less" : "More"}}</span>
                <!-- <div class="size mb-1" *ngIf="selectedProductInfo?.inventory">Inventory - {{selectedProductInfo?.inventory}}</div> -->
                <!-- <div class="size mb-1" *ngIf="selectedProductInfo?.inventory"></div> -->
                <div *ngIf="selectedProductInfo?.formatted_attributes?.length > 0">
                    <div class="mtb-10" *ngFor="let attr of selectedProductInfo?.formatted_attributes">
                        <div class="size">
                            {{attr?.attribute_name}}<span *ngIf="attr?.attributesList?.length == 1">- </span><span
                                *ngIf="attr?.attributesList?.length == 1">
                                {{attr?.attributesList[0]?.value}}
                            </span></div>
                        <div class="d-inline-block" *ngIf="attr?.attributesList?.length > 1">
                            <span class="dropdown-toggle gt-toggle w-100 pointer dropdown-size d-inline-block"
                                id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <span class="d-inline-block  notranslate">
                                    <span class="active-color v-bottom pr-15 attr-name">{{attr?.selectedAttr ?
                                        attr?.selectedAttr :
                                        attr?.attributesList[0]?.value}}</span>
                                </span>
                            </span>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <span *ngFor="let a of attr.attributesList" class="notranslate">
                                    <a class="dropdown-item fs-13 pointer"
                                        (click)="changeAttributes(a)">{{a.value}}</a></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-desc fs-10 mb-5 mt-10">
                    Quantity
                </div>
                <div class="d-flex align-items-center">
                    <span class="plusminus  bg-white " (click)="changeQuantity(selectedProductInfo,$event,'minus')">
                        <i class="fa fa-minus" aria-hidden="true"></i>
                    </span>
                    <span class="plr-15 pt-1 numbers notranslate align-middle">{{selectedProductInfo?.selectedQuantity}}
                    </span>
                    <span class="plusminus " (click)="changeQuantity(selectedProductInfo,$event,'add')">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </span>
                </div>
                <div class="cost mt-15 mb-10">
                    <span>Cost - <span>{{selectedProductInfo?.amt_after_dis | currency
                            :selectedProductInfo?.currency_type}}</span></span>
                </div>
                <span class="cart d-inline-block mt-10" (click)="addToCart()"
                    *ngIf="!selectedProductInfo?.editProduct"><span class="go-to-cart">
                        ADD TO CART</span></span>
                <span class="cart d-inline-block" (click)="goToCart()" *ngIf="enableGoToCart"><span
                        class="go-to-cart">GO TO CART</span></span>
                <span *ngIf="selectedProductInfo?.editProduct" class="cart d-inline-block mt-10"
                    (click)="updateProduct(selectedProductInfo)"><span class="go-to-cart">Update Product</span></span>
            </div>
            <!-- <div class="col-5 mt-10 img-pos" *ngIf="selectedProductInfo?.prod_imgs?.length > 0">
                <div class=" below-images no-gutters">
                    <img class="b-img" *ngFor="let img of selectedProductInfo.prod_imgs;let i = index"
                        (click)="changeImg(img,i)" src="{{img}}">
                </div>
            </div> -->
        </div>

    </ng-container>
    <!-- products display code ends here-->
    <!-- Shopping cart code starts here-->
    <ng-container *ngIf="activeBlock == 'Merchandise' && deviceData == 'web'">
        <div class="cart-box" [ngClass]="{'c-box':displayProducts?.length == 0}">
            <div class="row no-gutters">
                <div class="col-6">
                    <div>Shopping Cart</div>
                </div>
                <div class="col-6 text-right pr-5" *ngIf="cartProducts?.length > 0">
                    <span class="cart d-inline-block"><span class="go-to-cart checkout-btn"
                            (click)="checkout()">CHECKOUT</span></span>
                </div>
            </div>
            <ng-container *ngIf="cartProducts?.length === 0 && !cartProductsAvailable">
                <div class="text-center mt-20">No products added to the cart.</div>
            </ng-container>
            <div class="col-12 text-right mt-15 mb-10" *ngIf="cartProducts?.length > 0">Sub Total - {{productsTotal |
                currency
                :productCurrency}}</div>
            <ng-container *ngIf="cartProducts?.length > 0">
                <div class="product-conatiner mb-10 w-98" *ngFor="let prod of cartProducts">
                    <div class="row no-gutters">
                        <div class="col-2">
                            <div class="pr-img">
                                <img class="b-img" src="{{prod?.product_info?.product_img}}">
                            </div>
                        </div>
                        <div class="col-10 pl-10">
                            <div class="pr-heading p-name fs-12" matTooltipPosition="above"
                                [matTooltip]="prod?.product_info?.name?.length > 40 ? prod?.product_info?.name :''">
                                {{prod?.product_info?.name}}
                            </div>
                            <div class="p-desc text-capitalize line-clamp" matTooltipPosition="above"
                                [matTooltip]="prod?.product_info?.brand_name?.length > 40 ? prod?.product_info?.brand_name :''">
                                {{prod?.product_info?.brand_name}}</div>
                            <ng-container *ngIf="prod?.product_info?.attributes?.length > 0">
                                <div class="pr-costs mb-0" *ngFor="let attr of prod?.product_info?.attributes">
                                    <span>{{attr?.attribute_name}} - <span>{{attr?.selectedAttr ? attr?.selectedAttr :
                                            attr?.attributesList[0]?.value}}</span></span>
                                </div>
                            </ng-container>
                            <div class="pr-costs mb-0">
                                <span>Quantity - <span>{{prod?.quantity}}</span></span>
                            </div>
                            <div class="pr-costs mb-0">
                                <span class="cost">Cost - <span>{{prod?.totalPrice | currency
                                        :prod?.product_info?.currency_type}} </span><span class="fs-10"
                                        *ngIf="prod?.product_info.is_taxable">+ Taxes</span></span>
                            </div>
                            <!-- *ngIf="((prod?.inventory || prod?.product_info?.inventory) && prod?.product_info?.limited_inventory ) || !prod?.product_info?.limited_inventory" -->
                            <ng-container>
                                <i class="fa fa-pencil pr-10 pointer" matTooltipPosition="above" matTooltip="Edit"
                                    (click)="editProduct(prod)"></i><i class="fa fa-trash pointer"
                                    (click)="deleteProduct(prod)" matTooltipPosition="above" matTooltip="Delete"></i>
                            </ng-container>
                            <div class="pr-costs text-danger" *ngIf="prod?.invNotAvailable">
                                <span *ngIf="prod?.inventory">Only {{prod?.inventory}}
                                    available</span>
                                <span *ngIf="prod?.inventory == 0">Sold Out</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="mt-20" *ngIf="displayProducts?.length > 0 && productsList?.length > 0">
            <div class="marque-heading mb-10">
                Continue Shopping -
            </div>
            <div class="HVB-contnet dynamic-banner-top-slider HU-banner">
                <div id="myCarousel" class="carousel slide" data-ride="carousel" data-pause="hover"
                    data-interval="5000">

                    <div class="carousel-inner slider-height">
                        <div *ngFor="let product of displayProducts;let i =index" class="carousel-item" id="{{i}}"
                            [ngClass]="{'active' : i == 0}">
                            <div class="product-conatiner h-125">
                                <div class="row no-gutters">
                                    <div class="col-3">
                                        <div class="pr-img">
                                            <img class="a-img" src="{{product?.product_img}}">
                                        </div>
                                    </div>
                                    <div class="{{product.inventory || product.discount_percentage ? 'col-6' : 'col-9'}}"
                                        [ngClass]="{'pl-10':product?.product_img == assets_url + 'merch-default-image.png'}">
                                        <div class="pr-heading line-clamp-1 pr-5 text-uppercase"
                                            matTooltipPosition="above"
                                            [matTooltip]="product?.name?.length > 30 ? product?.name:''">
                                            {{product.name}}</div>
                                        <div class="p-desc line-clamp-1 pr-5" matTooltipPosition="above"
                                            [matTooltip]="product?.brand_name?.length > 30 ? product?.brand_name:''">
                                            {{product.brand_name}}</div>
                                        <!-- <div class="pr-heading w-100 ">{{product?.brand_name}}
                                        </div>
                                        <div class="mb-1 text-capitalize">{{product?.name}}</div> -->
                                        <!-- <div class="p-desc w-100 ">{{product?.short_description}}</div> -->
                                        <div class="p-cost">
                                            <div><span class="d-inline-flex">Cost -</span> </div>
                                            <div class="pl-1">
                                                <span class="d-block">
                                                    {{product.amt_after_dis | currency :product.currency_type }}</span>
                                                <span class="d-block old-amnt"
                                                    *ngIf="product.discount_percentage">{{product.price |
                                                    currency :product.currency_type}}</span>
                                            </div>
                                        </div>
                                        <span class="buy-now"
                                            [hidden]="product?.inventory == 0 && product?.limited_inventory"
                                            (click)="buyProduct(product)">
                                            BUY NOW
                                        </span>
                                        <span class="buy-now sold-out"
                                            *ngIf="product?.inventory == 0 && product?.limited_inventory">
                                            SOLD OUT
                                        </span>
                                    </div>
                                    <div class="col-3" *ngIf="product.inventory || product.discount_percentage">
                                        <div class="relative h-100">
                                            <div class="my-ab">
                                                <span class=" p-5 p-remaining" *ngIf="product.inventory">
                                                    <div class="img-div">
                                                        <!-- <img [src]="assets_url + 'merch/Stock.svg'"> -->
                                                        <app-svg [icon]="'merch-stock-pentanary'"></app-svg>
                                                    </div>

                                                    <div class="remain-div ">
                                                        <span class="d-block pentanary-bg-color">{{product.inventory}}
                                                        </span>
                                                        <span class="pentanary-bg-color">LEFT</span>
                                                    </div>
                                                </span>

                                                <span class="mt-2 d-block  ptb-10 plr-5"
                                                    *ngIf="product.discount_percentage">
                                                    <div class="relative p-discount ">
                                                        <!-- <img [src]="assets_url + 'merch/Discount.svg'" alt=""> -->
                                                        <app-svg [icon]="'merch-discount-pentanary'"></app-svg>
                                                        <span class="d-block text-center dis-txt w-100 pentanary-bg-color "><span
                                                                class="d-block">{{product.discount_percentage}}%</span>
                                                            <span class="d-block text-center"> OFF</span>
                                                        </span>
                                                    </div>
                                                </span>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev"
                                *ngIf="displayProducts.length > 1">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" *ngIf="displayProducts.length > 1"></span>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
            <!-- <marquee direction="left" onmouseover="this.stop();" onmouseout="this.start();" scrollamount="2">
                <div class="row" >
                <div class="col-10 product-conatiner mr-10 h-125" *ngFor="let product of displayProducts">
                    <div class="row no-gutters">
                        <div class="col-3">
                            <div class="pr-img">
                                <img class="a-img" src="{{product?.product_img}}">
                            </div>
                        </div>
                        <div class="{{product.inventory || product.discount_percentage ? 'col-6' : 'col-9'}}">
                            <div class="pr-heading line-clamp-1 pr-5 text-uppercase" matTooltipPosition="above"
                                [matTooltip]="product?.name?.length > 30 ? product?.name:''">
                                {{product.name}}</div>
                            <div class="p-desc line-clamp-1 pr-5" matTooltipPosition="above"
                                [matTooltip]="product?.brand_name?.length > 30 ? product?.brand_name:''">
                                {{product.brand_name}}</div>
                            <div class="p-cost">
                                <div><span class="d-inline-flex">Cost -</span> </div>
                                <div class="pl-1">
                                    <span class="d-block">
                                        {{product.amt_after_dis | currency :product.currency_type }}</span>
                                    <span class="d-block old-amnt" *ngIf="product.discount_percentage">{{product.price |
                                        currency :product.currency_type}}</span>
                                </div>
                            </div>
                            <span class=" buy-now" [hidden]="product?.inventory == 0 && product?.limited_inventory" (click)="buyProduct(product)">
                                BUY NOW
                            </span>
                            <span class="buy-now sold-out" *ngIf="product?.inventory == 0 && product?.limited_inventory">
                                SOLD OUT
                            </span>
                        </div>
                        <div class="col-3" *ngIf="product.inventory || product.discount_percentage">
                            <div class="relative h-100">
                                <div class="my-ab">
                                    <span class=" p-5 p-remaining" *ngIf="product.inventory">
                                        <div class="img-div">
                                            <img src="assets/merch/Stock.svg">
                                        </div>

                                        <div class="remain-div "><span class="d-block">{{product.inventory}} </span>
                                            <span>LEFT</span>
                                        </div>
                                    </span>

                                    <span class="mt-2 d-block  ptb-10 plr-5" *ngIf="product.discount_percentage">
                                        <div class="relative p-discount ">
                                            <img src="assets/merch/Discount.svg" alt="">
                                            <span class="d-block text-center dis-txt w-100"><span
                                                    class="d-block">{{product.discount_percentage}}%</span>
                                                <span class="d-block text-center"> OFF</span>
                                            </span>
                                        </div>
                                    </span>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </marquee> -->
        </div>
    </ng-container>
    <!-- Shopping cart code ends here-->
    <ng-container *ngIf="deviceData !='web'">
        <div fxFlex="100%" class="mb-15">
            <a class="logo pointer" class="logo"><img height="40" [src]="clientDetails.header_logo"></a>
        </div>
        <div fxFlex="100%" *ngIf="paymentSuccess" class="mtb-10">
            ORDER DETAILS
        </div>
        <ng-container *ngIf="continueSession || cartUrl">
            <div class="text-center mt-30">
                <div class="mb-20">Please click on "{{cartUrl ? "Continue" : "Pay"}}" button to proceed further.</div>
                <ng-container *ngIf="!cartUrl">
                    <a class="flat-primary-button bg-light mr-20 h-40 plr-25 ptb-10"
                        *ngIf="route.snapshot.queryParams.user_id || deviceData != 'web'" fxShow.xs="true" fxHide
                        target="_other" rel="nofollow" [href]="streamUrl">Go To Stream123</a>

                    <button mat-flat-button class="flat-primary-button" id="proceed-button"
                        (click)="proceedToCheckout()">Proceed to pay</button>
                </ng-container>
                <ng-container *ngIf="cartUrl">
                    <a class="flat-primary-button bg-light mr-20 h-40 plr-25 ptb-10"
                        *ngIf="route.snapshot.queryParams.user_id || deviceData != 'web'" target="_other" rel="nofollow"
                        [href]="cartUrl">Continue</a>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
    <div *ngIf="displayTimer && (showAddressForms || showPaymentForm)" class="pb-10 fs-16">Complete Payment In: <i
            class="fa fa-clock-o text-info"></i> <span class="text-info pl-10">{{displayTimer}}</span>
    </div>
    <!-- Shipping address code ends here-->
    <div [hidden]="!showAddressForms">
        <div class="radio-btn">
            <div [hidden]="!userInfo?.id">
                <app-default-address></app-default-address>
            </div>
        </div>
    </div>
    <ng-container *ngIf="showAddressForms">
        <div fxFlex="100%" *ngIf="digitalProducts?.length > 0" [ngClass]="{'pt-10':savedCardsList?.length > 0}">
            <mat-form-field class="w-100">
                <mat-label>Email</mat-label>
                <input matInput placeholder="" [(ngModel)]="email" required>
            </mat-form-field>
        </div>
        <div class="mb-5 fs-15" *ngIf="showAddressForms && showShippingForm && newShippingForm">Shipping Address</div>
        <div [ngClass]="{'add-block':deviceData == 'web' && productsList?.length<=0,'add-block-1':deviceData == 'web' && productsList?.length>0,'pt-15':deviceData !='web'}"
            fxLayout="column" *ngIf="showAddressForms && showShippingForm && newShippingForm">
            <div fxLayout="column">
            
                <div [ngClass]="{'add-block':deviceData == 'web' && productsList?.length<=0,'add-block-1':deviceData == 'web' && productsList?.length>0 }">
                    <form class="w-100" [formGroup]="shippingForm">
                        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="15px grid">
                            <div fxFlex="100%">
                                <mat-form-field class="w-100" *ngIf="countryChanged">
                                    <mat-label>Country</mat-label>
                                    <input matInput placeholder="" name="Country" [matAutocomplete]="auto"
                                        (input)="filterCountry('getShippingValue')" formControlName="country" required>
                                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                                        (optionSelected)="selectCountry($event.option,'shippingForm');">
                                        <mat-option *ngFor="let country of shippingCountriesList;" [value]="country">
                                            <span>{{country.name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="shippingForm.get('country').hasError('required')">
                                        Please select country
                                    </mat-error>
                                    <mat-error *ngIf="!shippingForm.get('country').hasError('required') && 
                            shippingForm.get('country').hasError('mat-require-match')">
                                        Please select country from existing list
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="50%">
                                <mat-form-field class="w-100" *ngIf="countryChanged">
                                    <mat-label>
                                        <span *ngIf="shippingCountry.name != 'United Kingdom'">Address line
                                            1</span>
                                        <span *ngIf="shippingCountry.name == 'United Kingdom'">Address</span>
                                    </mat-label>
                                    <input (blur)="checkShippingAddress()" matInput placeholder=""
                                        formControlName="address1" ngx-gp-autocomplete [options]="options"
                                        (onAddressChange)="getSelectedAddress($event,'shippingForm')"
                                        (paste)="onPasteLocation($event,'shippingForm')" required />
                                    <mat-error *ngIf="shippingForm.get('address1').hasError('required')">
                                        Please enter address
                                    </mat-error>
                                </mat-form-field>
                                <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                            </div>
                            <div fxFlex="50%" *ngIf="shippingCountry.name != 'United Kingdom'">
                                <mat-form-field class="w-100">
                                    <input (blur)="checkShippingAddress()" matInput placeholder="Address line 2"
                                        autocomplete="disabled" formControlName="address2">
                                </mat-form-field>
                            </div>
                            <div fxFlex="50%">
                                <mat-form-field class="w-100">
                                    <input (blur)="checkShippingAddress()" matInput placeholder="City"
                                        formControlName="city" required>
                                    <mat-error *ngIf="shippingForm.get('city').hasError('required')">
                                        Please enter city
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="50%" *ngIf="shippingCountry.stateless != 'yes'">
                                <mat-form-field class="w-100">
                                    <input (blur)="checkShippingAddress()" matInput placeholder="State"
                                        formControlName="state" required>
                                    <mat-error *ngIf="shippingForm.get('state').hasError('required')">
                                        Please enter state
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="27%" class="mb-10">
                                <mat-form-field class="w-100" *ngIf="shippingCountry.name != 'United Kingdom'">
                                    <mat-label><span>Zip code</span></mat-label>
                                    <input (blur)="checkShippingAddress()" matInput placeholder="" formControlName="zip"
                                        required>
                                    <mat-error *ngIf="shippingForm.get('zip').hasError('required')">
                                        <span>Please enter zip code</span>
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-100" *ngIf="shippingCountry.name == 'United Kingdom'">
                                    <mat-label><span>Postal code</span></mat-label>
                                    <input (blur)="checkShippingAddress()" matInput placeholder="" formControlName="zip"
                                        required>
                                    <mat-error *ngIf="shippingForm.get('zip').hasError('required')">
                                        <span>Please enter postal code</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="73%" class="phone-number-placeholder" [ngClass]="{'phone-number-placeholder-1':productsList && productsList.length > 0}">
                                <span class="placeholder-label">Phone Number
                                    <span
                                        [ngClass]="{'placeholder-label-required' : (shippingForm.get('phone_number').hasError('required') && businessPhoneValue.touched) }">*</span>
                                </span>
                                <mat-form-field class="w-100 country-flag-txt" >

                                    <input matInput countryFlagPhone allowValues isInputType="phone_number"
                                        formControlName="phone_number" required>
                                   <mat-error *ngIf="shippingForm.get('phone_number').hasError('required')">
                                       Please enter phone number
                                   </mat-error>
                                   <mat-error *ngIf="!shippingForm.get('phone_number').hasError('required') && 
                                   shippingForm.get('phone_number').hasError('isInvalid')">
                                       Please enter valid phone number
                                   </mat-error>

                                    <!-- <input matInput hidden="true" />
                                    <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                        [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
                                        [searchCountryFlag]="true"
                                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                        [selectFirstCountry]="true" [selectedCountryISO]="selectedCountry"
                                        [maxLength]="15" [phoneValidation]="true" [separateDialCode]="separateDialCode"
                                        name="phone" formControlName="phone_number" class="phonenumber">
                                    </ngx-intl-tel-input>
                                    <mat-hint
                                        *ngIf="shippingForm.get('phone_number').hasError('required') && businessPhoneValue.touched">
                                        Please enter phone number
                                    </mat-hint>
                                    <mat-hint
                                        *ngIf="!shippingForm.get('phone_number').hasError('required') && 
                                        (businessPhoneValue.invalid || (businessPhoneValue.touched && businessPhoneValue.invalid))">
                                        Please enter valid phone number
                                    </mat-hint> -->
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Billing address code starts here-->
        <div fxFlex="100%" *ngIf="showBillingForm && !sameBillingAddress">
            <div class="fs-15" [ngClass]="{'pt-15':showShippingForm,'pb-10':!showShippingForm}">Billing Address</div>
        </div>
        <div [hidden]="selectedCard?.id || selectedBillingAddress?.line1" class=" checkbox tertiary-bg-font-color2 mer-label">
            <mat-checkbox
                *ngIf="showAddressForms && showShippingForm && newShippingForm && (showBillingForm || !selectedCard?.id || !selectedBillingAddress?.line1)"
                name="addressval" class="fw-300 mt-10 checkbox app-primary-bg" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="sameBillingAddress" [ngClass]="{'slick-disabled':shippingForm?.invalid}"
                [disabled]="shippingForm?.invalid" (change)="populateBillingAddress($event)">
             <span class="tertiary-bg-font-color2">Same as shipping address</span>   
            </mat-checkbox>
        </div>
        <form class="display-block" [ngClass]="{'add-block':deviceData == 'web','pr-15':deviceData !='web'}"
            *ngIf="showBillingForm && !sameBillingAddress" [formGroup]="billingForm" autocomplete="off">
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="15px grid">
                <div fxFlex="100%">
                    <mat-form-field class="w-100">
                        <mat-label>Country</mat-label>
                        <input matInput placeholder="" name="Country" [matAutocomplete]="auto"
                            (input)="filterCountry('getBillingValue')" formControlName="country"
                            (blur)="setCountry($event)" required>
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                            (optionSelected)="selectCountry($event.option,'billingForm');">
                            <mat-option *ngFor="let country of countriesList;" [value]="country">
                                <span>{{country.name}}</span>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="billingForm.get('country').hasError('required')">
                            Please select country
                        </mat-error>
                        <mat-error *ngIf="!billingForm.get('country').hasError('required') && 
                            billingForm.get('country').hasError('mat-require-match')">
                            Please select country from existing list
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="50%">
                    <mat-form-field class="w-100" *ngIf="countryChanged">
                        <mat-label><span *ngIf="billingCountry.name != 'United Kingdom'">Address line
                                1</span><span *ngIf="billingCountry.name == 'United Kingdom'">Address</span>
                        </mat-label>
                        <input matInput placeholder="" formControlName="address1" ngx-gp-autocomplete
                            [options]="options" (onAddressChange)="getSelectedAddress($event, 'billingForm')"
                            (paste)="onPasteLocation($event,'billingForm')" required />
                        <mat-error *ngIf="billingForm.get('address1').hasError('required')">
                            Please enter address
                        </mat-error>
                    </mat-form-field>
                    <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                </div>
                <div fxFlex="50%" *ngIf="billingCountry.name != 'United Kingdom'">
                    <mat-form-field class="w-100">
                        <mat-label>Address line 2</mat-label>
                        <input matInput placeholder="" autocomplete="disabled" formControlName="address2">
                    </mat-form-field>
                </div>
                <div fxFlex="50%">
                    <mat-form-field class="w-100">
                        <mat-label>City</mat-label>
                        <input matInput placeholder="" formControlName="city" required>
                        <mat-error *ngIf="billingForm.get('city').hasError('required')">
                            Please enter city
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="50%" *ngIf="billingCountry.name != 'United Kingdom'">
                    <mat-form-field class="w-100">
                        <mat-label>State</mat-label>
                        <input matInput placeholder="" formControlName="state" required>
                        <mat-error *ngIf="billingForm.get('state').hasError('required')">
                            Please enter state
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="50%">
                    <mat-form-field class="w-100" *ngIf="billingCountry.name != 'United Kingdom'">
                        <mat-label><span>Zip code</span></mat-label>
                        <input matInput placeholder="" formControlName="zip" required>
                        <mat-error *ngIf="billingForm.get('zip').hasError('required')">
                            <span>Please enter zip code</span>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100" *ngIf="billingCountry.name == 'United Kingdom'">
                        <mat-label><span>Postal code</span></mat-label>
                        <input matInput placeholder="" formControlName="zip" required>
                        <mat-error *ngIf="billingForm.get('zip').hasError('required')">
                            <span>Please enter postal code</span>
                        </mat-error>
                    </mat-form-field>

                </div>
            </div>
        </form>
        <div fxFlex="100%" class="text-right pr-0 mtb-20" *ngIf="showAddressForms">
            <a class="flat-secondary-dialog-button bg-secondary mr-20 h-40 plr-25 ptb-10 text-info"
                *ngIf="route.snapshot.queryParams.user_id || deviceData != 'web'" fxShow.xs="true" fxHide
                target="_other" rel="nofollow" [href]="streamUrl">Cancel</a>
            <button mat-flat-button *ngIf="deviceData == 'web'" class="flat-secondary-button secondary-bg-btn1"[ngClass]="productsList?.length>0?'mr-10':'mr-20'"
                (click)="close(paymentType)">Cancel</button>
            <button mat-flat-button class="flat-primary-button primary-bg-button" [ngClass]="{'mr-15':deviceData !='web'}"
                id="proceed-button" (click)="proceed()">Proceed</button>
        </div>
    </ng-container>
    <!-- Billing address code ends here-->
    <!-- Order summary code starts here-->
    <div [hidden]="!showPaymentForm">
        <div class="fs-18 pb-10">ORDER DETAILS</div>
        <div class="row pt-10 sum-bg mb-10" *ngIf="showPaymentForm">
            <div class="col-6">
                <div class="fs-16">Billing Address</div>
                <div *ngIf="billingForm.get('address1').value && !selectedCard?.id && !selectedBillingAddress?.line1">
                    {{billingForm.get('address1').value}}, <span
                        *ngIf="billingForm.get('address2').value">{{billingForm.get('address2').value}},</span><br>
                    {{billingForm.get('city').value}}, {{billingForm.get('state').value}},<br>
                    {{billingForm.get('country').value?.name}}, {{billingForm.get('zip').value}}<br>
                    <span (click)="editAddress()" class="pointer text-info fs-16">Edit</span>
                </div>
                <div *ngIf="selectedBillingAddress && selectedBillingAddress.line1">
                    {{selectedBillingAddress.line1}}, <span
                        *ngIf="selectedBillingAddress.line2">{{selectedBillingAddress.line2}},</span><br>
                    {{selectedBillingAddress.city}}, {{selectedBillingAddress.state}},<br>
                    {{selectedBillingAddress.country}}, {{selectedBillingAddress.zip}}<br>
                    <span (click)="editAddress()" class="pointer text-info fs-16">Edit</span>
                </div>
            </div>
            <div class="col-6" *ngIf="showShippingForm">
                <div class="fs-16">Shipping Address</div>
                <div *ngIf="shippingForm.get('address1').value">
                    {{shippingForm.get('address1').value}}, <span
                        *ngIf="shippingForm.get('address2').value">{{shippingForm.get('address2').value}},</span><br>
                    {{shippingForm.get('city').value}}, {{shippingForm.get('state').value}},<br>
                    {{shippingForm.get('country').value?.name}}, {{shippingForm.get('zip').value}}<br>
                    <span (click)="editAddress()" class="pointer text-info fs-16">Edit</span>
                </div>
                <div *ngIf="selectedShippingAddress && selectedShippingAddress.line1">
                    {{selectedShippingAddress.line1}}, <span
                        *ngIf="selectedShippingAddress.line2">{{selectedShippingAddress.line2}},</span><br>
                    {{selectedShippingAddress.city}}, {{selectedShippingAddress.state}},<br>
                    {{selectedShippingAddress.country}}, {{selectedShippingAddress.zip}}<br>
                    <span (click)="editAddress()" class="pointer text-info fs-16">Edit</span>
                </div>
            </div>
        </div>
        <ng-container *ngIf="cartProducts?.length > 0">
            <div class="sum-bg plr-15 pb-10">
                <div class="fs-16 ptb-10">Summary</div>
                <div class="fs-15 border-bottom pb-10">
                    <div class="row pb-5" *ngFor="let product of cartProducts">
                        <div class="col-7">
                            <div>{{product?.quantity}} x {{product?.product_info?.name}}</div>
                        </div>
                        <div class="col-5 text-right pr-20">
                            <div>{{product?.totalPrice| currency
                                :product?.product_info?.currency_type}}</div>
                        </div>
                    </div>
                </div>
                <div class="row fs-15 ptb-10 border-bottom no-gutters">
                    <div class="col-7">
                        SubTotal
                    </div>
                    <div class="col-5 text-right">
                        <div>{{productsTotal | currency:productCurrency}}</div>
                    </div>
                    <div class="col-7 pt-5" *ngIf="shippingCost && showShippingForm">
                        Shipping Cost
                    </div>
                    <div class="col-5 pt-5 text-right" *ngIf="shippingCost && showShippingForm">
                        <div>{{shippingCost | currency:productCurrency}}</div>
                    </div>
                    <div class="col-7 pt-5" *ngIf="taxAmount">
                        Sales Tax
                    </div>
                    <div class="col-5 pt-5 text-right" *ngIf="taxAmount">
                        <div>{{taxAmount | currency:productCurrency}}</div>
                    </div>
                    <div class="col-7 pt-5" *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">
                        Processing Fee
                    </div>
                    <div class="col-5 pt-5 text-right" *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">
                        {{processingFee
                        |
                        currency:productCurrency}}
                    </div>
                </div>
                <div class="row fs-17 pt-10">
                    <div class="col-7">
                        Total
                    </div>
                    <div class="col-5 text-right pr-20">
                        <div>{{finalAmount | currency:productCurrency}}</div>
                    </div>
                </div>
                <div *ngIf="selectedTransaction == 'crypto'" class="text-right">
                    <!-- {{finalAmount | currency:currency}} -->
                    <span  matTooltip="{{crypto_amount}}"  class="fs-17 cryptoValue">(<img src="{{cryptoSymbol}}" width="17px" class="mb-1 mr-1"/>{{sliced_crypto_amount}}...{{cryptoToken}})</span>
            
                 
                    </div>
            </div>
        </ng-container>
        <!-- <h6 class="heading mtb-10" *ngIf="isShowT_C"
            [ngClass]="{'pt-20':streamInfo?.stream_payment_mode == 'free' && totalTicketsCount == 1}">
            Terms and Conditions
        </h6>
        <div class="bg-secondary mb-15" *ngIf="isShowT_C">
            <app-event-terms-conditions></app-event-terms-conditions>
        </div>
        <mat-checkbox name="isAgrees" class="fw-300 t_c_checkBox" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="isAgrees">
        </mat-checkbox>
        <span> I agree to the event <span class="t_c_pointer" (click)="showHideTermsAndConditions()">Terms and
                Conditions.</span> </span> -->
                <app-payment-transactions (getTransactionDetails)="calFee($event)" [currentBlock]="currentBlock"></app-payment-transactions>
        <!-- <form class="pr-10" (ngSubmit)="makePayment()" [hidden]="selectedCard?.id">
            <div id="form-field">
                <div fxFlex="100%" class="text-center" fxLayout="column">
                    <div id="card-info" #cardInfo></div>
                    <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mb-20">
                        <mat-icon class="c-error">cancel
                        </mat-icon>
                        &nbsp;{{ cardError }}
                    </mat-error>
                    <div class="text-left app-ticket fs-16">
                        <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="save_card" (change)="saveCard($event)">
                        </mat-checkbox>Save card for future payments
                    </div>
                    <div fxLayout="row" class="mtb-20" fxLayoutAlign="center center">
                        <a class="flat-secondary-dialog-button bg-secondary mr-20 h-40 p-0 pt-10"
                            *ngIf="route.snapshot.queryParams.user_id || deviceData != 'web'" fxShow.xs="true" fxHide
                            target="_other" rel="nofollow" [href]="streamUrl">Cancel</a>
                        <button type="button" *ngIf="deviceData == 'web'" mat-flat-button
                            class="flat-secondary-dialog-button mr-20 cancel-l-btn"
                            (click)="closeForm()">Cancel</button>
                        <button mat-flat-button class="flat-primary-button" id="submit-button" [disabled]="isPayment"
                            type="submit">Place
                            Order</button>
                    </div>
                </div>
            </div>
        </form> -->
        <!-- <div fxLayout="row" class="mtb-20" fxLayoutAlign="center center"
            *ngIf="!showBillingForm && !addNewCard && selectedCard?.id">
            <a class="flat-secondary-dialog-button bg-secondary mr-20 h-40 p-0 pt-10"
                *ngIf="route.snapshot.queryParams.user_id || deviceData != 'web'" fxShow.xs="true" fxHide
                target="_other" rel="nofollow" [href]="streamUrl">Cancel</a>
            <button type="button" *ngIf="deviceData == 'web'" mat-flat-button
                class="flat-secondary-dialog-button mr-20 cancel-l-btn" (click)="closeForm()">Cancel</button>
            <button mat-flat-button class="flat-primary-button" id="submit-button" [disabled]="isPayment"
                (click)="makePayment('card')">Place
                Order</button>
        </div> -->
    </div>
    <!-- Order summary code ends here-->
    <div *ngIf="paymentSuccess" id="payment_success" fxLayout="column" fxFlex="100%"
        class="ff fs-16 mt-10 text-center p-40 lh-24">
        <div>Thank you</div>
        <div>Your order was successfully completed.<span *ngIf="deviceData !='web'">Go to the application.</span></div>
        <div class="text-center">
            <button mat-flat-button *ngIf="deviceData == 'web'" class="flat-secondary-button secondary-bg-btn1 mt-20 "
                (click)="close()">Close</button>
            <div class="text-center mt-20" *ngIf="deviceData != 'web'" fxFlex="100%" fxLayoutAlign="center center">
                <a class="flat-primary-button schedule-btn" target="_other" rel="nofollow" [href]="streamUrl">Go
                    To
                    {{streamInfo.stream_status == 'pending' || streamInfo.stream_status == 'progress' ? 'Stream' :
                    'VOD'}}</a>
            </div>
        </div>
    </div>
</div>